import React from "react"

export function extractTextFromJSX(node) {
    if (typeof node === "string" || typeof node === "number") {
        return String(node)
    }
    if (Array.isArray(node)) {
        return node.map(extractTextFromJSX).join(" ")
    }
    if (React.isValidElement(node)) {
        return extractTextFromJSX(node.props.children)
    }
    return ""
}
